export function Upgrade() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="4" fill="url(#paint0_linear_12837_43389)" />
      <path
        d="M17.9027 12.0272C15.8365 11.5941 14.2215 9.9791 13.7884 7.91288C13.7352 7.65924 13.5115 7.47754 13.2523 7.47754C12.9931 7.47754 12.7693 7.65924 12.7162 7.91291C12.2831 9.9791 10.6681 11.594 8.60191 12.0271C8.34824 12.0803 8.1665 12.304 8.1665 12.5632C8.1665 12.8224 8.3482 13.0462 8.60191 13.0993C10.6681 13.5325 12.283 15.1474 12.7161 17.2136C12.7692 17.4673 12.993 17.649 13.2522 17.649C13.5114 17.649 13.7351 17.4673 13.7883 17.2136C14.2214 15.1474 15.8364 13.5325 17.9026 13.0994C18.1563 13.0463 18.338 12.8226 18.338 12.5633C18.338 12.3041 18.1563 12.0804 17.9027 12.0272Z"
        fill="white"
      />
      <path
        d="M16.9974 21.0763C16.0239 20.8722 15.263 20.1114 15.0589 19.1378C15.0058 18.8841 14.7821 18.7024 14.5228 18.7024C14.2636 18.7024 14.0399 18.8841 13.9867 19.1378C13.7826 20.1113 13.0217 20.8722 12.0482 21.0763C11.7945 21.1294 11.6128 21.3532 11.6128 21.6124C11.6128 21.8716 11.7945 22.0953 12.0482 22.1485C13.0217 22.3526 13.7826 23.1135 13.9867 24.087C14.0398 24.3407 14.2635 24.5224 14.5228 24.5224C14.782 24.5224 15.0057 24.3407 15.0589 24.087C15.263 23.1135 16.0239 22.3526 16.9974 22.1485C17.2511 22.0953 17.4328 21.8716 17.4328 21.6124C17.4328 21.3532 17.2511 21.1295 16.9974 21.0763Z"
        fill="white"
      />
      <path
        d="M24.3978 16.0045C23.0819 15.7287 22.0535 14.7002 21.7777 13.3844C21.7245 13.1307 21.5008 12.949 21.2416 12.949C20.9824 12.949 20.7586 13.1306 20.7055 13.3844C20.4296 14.7002 19.4012 15.7286 18.0853 16.0045C17.8316 16.0576 17.6499 16.2814 17.6499 16.5406C17.6499 16.7998 17.8316 17.0235 18.0853 17.0767C19.4011 17.3525 20.4296 18.381 20.7054 19.6968C20.7586 19.9505 20.9823 20.1322 21.2415 20.1322C21.5007 20.1322 21.7244 19.9506 21.7776 19.6968C22.0535 18.381 23.0819 17.3525 24.3978 17.0768C24.6514 17.0236 24.8332 16.7998 24.8332 16.5406C24.8332 16.2814 24.6515 16.0577 24.3978 16.0045Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12837_43389"
          x1="-4.66667"
          y1="16"
          x2="53.7333"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.142579" stopColor="#176984" />
          <stop offset="0.94179" stopColor="#64CCC5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
